<div class="app-trimming-player">
  <div class="app-select-segment">
    <div class="app-select-segment-video">
      <video #target class="app-video vjs-big-play-button video-js"
             data-setup='{ "inactivityTimeout": 0 }' controls></video>
    </div>
  </div>
</div>
